export const MAXSPEED = 3;
export const WARNINGSPEED = 100;
